import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Field} from "../shared/model/field";
import {Cpu} from "../shared/model/cpu";
import {Court} from "../shared/model/court";

@Component({
  selector: 'app-agenda-detail',
  templateUrl: './agenda-detail.component.html',
  styleUrls: ['./agenda-detail.component.css']
})
export class AgendaDetailComponent implements OnInit {

  @Input()
  court: Court;

  @Output()
  onErrorDone = new EventEmitter<boolean>();

  visibleError: boolean = true;
  visibleErrorAnimate: boolean = true;

  constructor() {
  }

  formDone(done: boolean) {
    this.onErrorDone.emit(true);  // hide modal add screen
  }

  ngOnInit() {
    //console.log("ngOnInit: ErrorDetailComponent");
    this.show();
  }

  public show(): void {
    this.visibleError = true;
    setTimeout(() => this.visibleErrorAnimate = true);
  }

  public hide(): void {
    this.visibleErrorAnimate = false;
    setTimeout(() => this.visibleError = false, 300);
  }

  public save() {
    this.visibleError = false;
    this.formDone(true);
  }

  public translateBoolean( b: boolean ): string {
    return b ? "l.on" : "l.off";
  }

}
